import type { RouteRecordRaw } from 'vue-router'
import NProgress from 'nprogress'
// import generatedRoutes from 'virtual:generated-pages'
// import { setupLayouts } from 'virtual:meta-layouts'
import { createRouter, createWebHashHistory } from 'vue-router'
import { checkMobile } from '@/utils'
import { isLogin } from '@/utils/auth'
import { menusRoutes, mobileMenusRoutes } from './modules/root'
import 'nprogress/nprogress.css'

let routes: RouteRecordRaw[] = []

// 判断是否为移动端
const isMobile = computed(() => {
  return checkMobile()
})

const routesContext: any = import.meta.glob('./modules/*.ts', { eager: true })
Object.keys(routesContext).forEach((v) => {
  routes.push(routesContext[v].default)
})
routes.push({
  path: '/:pathMatch(.*)*',
  component: () => import('@/views/[...all].vue'),
  meta: {
    title: '找不到页面',
  },
})
routes = routes.flat()

// generatedRoutes.forEach((v) => {
//   routes.push(v?.meta?.layout !== false ? setupLayouts([v])[0] : v)
// })

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

const whiteList = ['/login', '/mobile/login']

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()
  NProgress.start()
  if (isLogin()) {
    if (to.path === '/login') {
      if (isMobile.value) {
        next({ path: '/mobile/knowledgeBase/course' })
      }
      else {
        next({ path: '/' })
      }
    }
    else {
      if (!userStore.userInfo) {
        userStore.getInfo().then(() => {
          if (isMobile.value) {
            mobileMenusRoutes.forEach((route) => {
              if (route.meta?.roles && Array.isArray(route.meta.roles) && route.meta.roles.includes(userStore.userInfo?.role)) {
                // 根据角色显示对应菜单
                userStore.menus.push({
                  name: route.meta.title,
                  path: route.path,
                  menuPath: route.meta.menuPath,
                  hiddenActivePath: route.meta.hiddenActivePath,
                  linkType: route.meta.linkType,
                })
                // 根据角色动态添加路由
                router.addRoute(route)
              }
            })
          }
          else {
            menusRoutes.forEach((route) => {
              if (route.meta?.roles && Array.isArray(route.meta.roles) && route.meta.roles.includes(userStore.userInfo?.role)) {
                // 根据角色显示对应菜单
                userStore.menus.push({
                  name: route.meta.title,
                  path: route.path,
                  menuPath: route.meta.menuPath,
                  hiddenActivePath: route.meta.hiddenActivePath,
                  linkType: route.meta.linkType,
                })
                // 根据角色动态添加路由
                router.addRoute(route)
              }
            })
          }
          // 加载课程菜单名称
          userStore.loadCourseMenuName()
          next({ ...to, replace: true })
        }).catch(() => {
          userStore.logout()
        })
      }
      else {
        to.name && userStore.pageLog(to.name)
        if (to.path === '/synthesis/index') {
          const useSynthesis = useSynthesisStore()
          if (!useSynthesis.token) {
            useSynthesis.getToken().then(() => {
              next({ ...to, replace: true })
            }).catch(() => {
              ElMessage.error('虚拟仿真实验异常，请重试')
              next({ path: '/' })
            })
          }
          else {
            next()
          }
        }
        else {
          next()
        }
      }
    }
  }
  else {
    if (whiteList.includes(to.path)) {
      if (isMobile.value) {
        if (to.name === 'login') {
          return next({
            name: 'mobileLogin',
            query: {
              redirect: to.fullPath,
            },
          })
        }
      }
      else {
        if (to.name === 'mobileLogin') {
          return next({
            name: 'login',
            query: {
              redirect: to.fullPath,
            },
          })
        }
      }
      next()
    }
    else {
      if (isMobile.value) {
        next({
          name: 'mobileLogin',
          query: {
            redirect: to.fullPath,
          },
        })
      }
      else {
        next({
          name: 'login',
          query: {
            redirect: to.fullPath,
          },
        })
      }
    }
  }
})

router.afterEach((to) => {
  NProgress.done()
  useSettingsStore().setTitle(to.meta.title ?? '')
})

export default router
// import type { RouteRecordRaw } from 'vue-router'
// import NProgress from 'nprogress'
// // import generatedRoutes from 'virtual:generated-pages'
// // import { setupLayouts } from 'virtual:meta-layouts'
// import { createRouter, createWebHashHistory } from 'vue-router'
// import { checkMobile } from '@/utils'
// import { isLogin } from '@/utils/auth'
// import { menusRoutes, mobileMenusRoutes } from './modules/root'
// import 'nprogress/nprogress.css'

// let routes: RouteRecordRaw[] = []

// // 判断是否为移动端
// const isMobile = computed(() => {
//   return checkMobile()
// })

// const routesContext: any = import.meta.glob('./modules/*.ts', { eager: true })
// Object.keys(routesContext).forEach((v) => {
//   routes.push(routesContext[v].default)
// })
// routes.push({
//   path: '/:pathMatch(.*)*',
//   component: () => import('@/views/[...all].vue'),
//   meta: {
//     title: '找不到页面',
//   },
// })
// routes = routes.flat()

// // generatedRoutes.forEach((v) => {
// //   routes.push(v?.meta?.layout !== false ? setupLayouts([v])[0] : v)
// // })

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes,
// })

// const whiteList = ['/login', '/mobile/login']

// router.beforeEach((to, _from, next) => {
//   const userStore = useUserStore()
//   NProgress.start()

//   // ===== 开发模式：跳过登录验证 =====
//   if (import.meta.env.DEV) {
//     // 开发模式下直接添加所有动态路由
//     const hasDynamicRoutes = router.hasRoute('some-route-name-check') // 检查路由是否已添加

//     if (!hasDynamicRoutes) {
//       // 添加PC端所有路由（不按角色过滤）
//       menusRoutes.forEach((route) => {
//         router.addRoute(route)
//       })

//       // 添加移动端所有路由（不按角色过滤）
//       mobileMenusRoutes.forEach((route) => {
//         router.addRoute(route)
//       })

//       // 开发模式下可以初始化一些模拟数据
//       if (!userStore.userInfo) {
//         userStore.userInfo = {
//           id: 1,
//           username: 'admin',
//           role: 'admin', // 使用一个存在的角色
//           name: '管理员',
//           // 其他必要的字段
//         }

//         // 初始化菜单（开发模式下显示所有菜单）
//         userStore.menus = []
//         menusRoutes.forEach((route) => {
//           if (route.meta?.title) {
//             userStore.menus.push({
//               name: route.meta.title,
//               path: route.path,
//               menuPath: route.meta.menuPath || route.path,
//               hiddenActivePath: route.meta.hiddenActivePath || false,
//             })
//           }
//         })
//       }
//     }

//     // 特殊页面处理
//     if (to.path === '/synthesis/index') {
//       const useSynthesis = useSynthesisStore()
//       if (!useSynthesis.token) {
//         useSynthesis.getToken().then(() => {
//           next()
//         }).catch(() => {
//           console.warn('开发模式：虚拟仿真实验token获取失败，跳过验证')
//           next()
//         })
//         return
//       }
//     }

//     // 页面访问日志（开发模式下可选）
//     if (to.name && typeof userStore.pageLog === 'function') {
//       userStore.pageLog(to.name)
//     }

//     next()
//     return
//   }

//   /*
//   if (isLogin()) {
//     if (to.path === '/login') {
//       if (isMobile.value) {
//         next({ path: '/mobile/knowledgeBase/course' })
//       }
//       else {
//         next({ path: '/' })
//       }
//     }
//     else {
//       if (!userStore.userInfo) {
//         userStore.getInfo().then(() => {
//           if (isMobile.value) {
//             mobileMenusRoutes.forEach((route) => {
//               if (route.meta?.roles && Array.isArray(route.meta.roles) && route.meta.roles.includes(userStore.userInfo?.role)) {
//                 // 根据角色显示对应菜单
//                 userStore.menus.push({
//                   name: route.meta.title,
//                   path: route.path,
//                   menuPath: route.meta.menuPath,
//                   hiddenActivePath: route.meta.hiddenActivePath,
//                 })
//                 // 根据角色动态添加路由
//                 router.addRoute(route)
//               }
//             })
//           }
//           else {
//             menusRoutes.forEach((route) => {
//               if (route.meta?.roles && Array.isArray(route.meta.roles) && route.meta.roles.includes(userStore.userInfo?.role)) {
//                 // 根据角色显示对应菜单
//                 userStore.menus.push({
//                   name: route.meta.title,
//                   path: route.path,
//                   menuPath: route.meta.menuPath,
//                   hiddenActivePath: route.meta.hiddenActivePath,
//                 })
//                 // 根据角色动态添加路由
//                 router.addRoute(route)
//               }
//             })
//           }
//           next({ ...to, replace: true })
//         }).catch(() => {
//           userStore.logout()
//         })
//       }
//       else {
//         to.name && userStore.pageLog(to.name)
//         if (to.path === '/synthesis/index') {
//           const useSynthesis = useSynthesisStore()
//           if (!useSynthesis.token) {
//             useSynthesis.getToken().then(() => {
//               next({ ...to, replace: true })
//             }).catch(() => {
//               ElMessage.error('虚拟仿真实验异常，请重试')
//               next({ path: '/' })
//             })
//           }
//           else {
//             next()
//           }
//         }
//         else {
//           next()
//         }
//       }
//     }
//   }
//   else {
//     if (whiteList.includes(to.path)) {
//       if (isMobile.value) {
//         if (to.name === 'login') {
//           return next({
//             name: 'mobileLogin',
//             query: {
//               redirect: to.fullPath,
//             },
//           })
//         }
//       }
//       else {
//         if (to.name === 'mobileLogin') {
//           return next({
//             name: 'login',
//             query: {
//               redirect: to.fullPath,
//             },
//           })
//         }
//       }
//       next()
//     }
//     else {
//       if (isMobile.value) {
//         next({
//           name: 'mobileLogin',
//           query: {
//             redirect: to.fullPath,
//           },
//         })
//       }
//       else {
//         next({
//           name: 'login',
//           query: {
//             redirect: to.fullPath,
//           },
//         })
//       }
//     }
//   }
//   */

//   // ===== 生产环境临时替代方案：如果没有启用上面的代码，这里确保至少能跳转 =====
//   // 当你有后端服务后，删除下面的代码，并取消注释上面的生产环境代码
//   next()
// })

// router.afterEach((to) => {
//   NProgress.done()
//   useSettingsStore().setTitle(to.meta.title ?? '')
// })

// export default router
